import type { Ad } from '../../types';
import './AdCard.css';

interface AdCardProps {
  ad: Ad;
  onClick?: (adId: string) => void;
}

/**
 * 廣告卡片元件
 * [UPDATED v0.7.1] 對齊後端 API
 * 對應 UXC-advertising-AdCard-003
 */
const AdCard = ({ ad, onClick }: AdCardProps) => {
  const handleClick = () => {
    if (onClick) {
      onClick(ad.id);
    }
  };

  const handleKeyDown = (e: React.KeyboardEvent) => {
    if (e.key === 'Enter' && onClick) {
      onClick(ad.id);
    }
  };

  const imageUrl = ad.imageUrls && ad.imageUrls.length > 0 ? ad.imageUrls[0] : null;

  return (
    <article
      className={`ad-card ${ad.featured ? 'ad-card--featured' : ''}`}
      onClick={handleClick}
      onKeyDown={handleKeyDown}
      tabIndex={0}
      role="button"
      aria-label={`查看 ${ad.title} 詳情`}
    >
      {ad.featured && <span className="ad-card__badge">精選</span>}

      {imageUrl && (
        <div className="ad-card__image">
          <img
            src={imageUrl}
            alt={ad.title}
            loading="lazy"
          />
        </div>
      )}

      <div className="ad-card__content">
        <h3 className="ad-card__title">{ad.title}</h3>

        <p className="ad-card__company">{ad.storeName || '未知店家'}</p>

        {ad.description && (
          <p className="ad-card__summary">{ad.description}</p>
        )}

        <div className="ad-card__tags">
          <span className="ad-card__tag ad-card__tag--region">
            📍 {ad.region}
          </span>
          <span className="ad-card__tag ad-card__tag--service">
            🔧 {ad.category}
          </span>
        </div>

        {ad.specialOffer && (
          <div className="ad-card__offer">
            🎁 {ad.specialOffer}
          </div>
        )}

        <div className="ad-card__footer">
          <div className="ad-card__contact">
            <span>📞 {ad.phone || '未提供電話'}</span>
          </div>
          <button className="ad-card__cta">查看詳情</button>
        </div>
      </div>
    </article>
  );
};

export default AdCard;
